<template>
    <header class="layout-header">
        <ul class="ngui2-nav">
            <li class="">
                <a href="#">欢迎你，{{userInfo.name}}</a>
            </li>
            <li>
                <span v-if="['production','staging'].includes(env)">
                    <a class="logout" href="https://sso.sankuai.com/logout">退出</a>
                </span>
                <span v-else>
                    <a class="logout" href="http://develop.sso.test.sankuai.info/logout">退出</a>
                </span>
            </li>
        </ul>
    </header>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: 'navBar',
    computed: {
        ...mapState({
            userInfo: state => state.userInfo,
            env: state => state.ENV
        })
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
.layout-header {
    left:0;
    z-index:0;
}
.ngui2-nav li span {
    display: block;
    padding: 20px 15px;
    color: #475669;
}
</style>



// WEBPACK FOOTER //
// NavBar.vue?c36737b8